<template>
  <base-dialog show-close :visible.sync="visible">
    <template v-slot:header>保存为版本</template>
    <el-form
      class="form"
      :model="versionData"
      :rules="rules"
      ref="versionInfo"
      label-position="left"
      label-width="100px"
    >
      <el-form-item label="当前版本号">
        <el-input disabled :value="oldVersion"></el-input>
      </el-form-item>
      <el-form-item prop="version">
        <template slot="label">
          新版本号
          <span style="color:red">*</span>
          <el-tooltip content="由英文和数字符号组成" placement="bottom">
            <div class="el-icon-info" style="margin-left:5px"></div>
          </el-tooltip>
        </template>
        <el-input v-model="versionData.version"></el-input>
      </el-form-item>
      <el-form-item label="更新内容">
        <el-input type="textarea" :rows="4" v-model="versionData.desc"></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="saveVersion">确定</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import * as appApi from "@/api/userCenter/app"
export default {
  name: "save-version-dialog",
  components: { BaseDialog, BaseButton },
  data() {
    let validateVersion = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入版本号"))
      } else if (value === this.oldVersion) {
        callback(new Error("新版本号不能与当前版本号相同"))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      oldVersion: "",
      versionData: {
        version: ""
      },
      rules: {
        version: [{ validator: validateVersion, trigger: "blur" }]
      }
    }
  },
  methods: {
    init(id, version) {
      if (this.$refs.versionInfo) this.$refs.versionInfo.resetFields()
      this.versionData.templateId = id
      this.oldVersion = version
      this.visible = true
    },
    saveVersion() {
      this.$refs.versionInfo.validate(valid => {
        if (!valid) return
        appApi.commitAppTemplate(this.versionData).then(res => {
          this.$message.success("已保存为版本")
          this.$emit("refresh")
          this.visible = false
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-top: 10px;
}
</style>
